<template>
  <div>
    <b><small>{{ $t('a') }}</small></b>
    <ais-refinement-list
      attribute="profile.languages.code"
      :transform-items="transformItems"
      operator="and"
    />
  </div>
</template>

<script>
const allLanguages = require('@/assets/app/data/languages.json')
import { mapGetters } from "vuex";

export default {
  components: {
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },
  methods: {
    transformItems(items) {
      return items.map(item => ({
        ...item,
        label: this.getLanguageName(item.label),
      }));
    },
    getLanguageName(languageCode) {
      const interfaceLanguage = this.user.data.locale // 'fr' or 'en'
      return allLanguages.find(l => l.iso_code === languageCode).descriptions[interfaceLanguage]
    }
  },
};
</script>



<i18n>
{
  "fr": {
    "a": "Langues"
  },
  "en": {
    "a": "Languages"
  }
}
</i18n>